import { useEffect } from "react";

import { useAuth } from "@/contexts/auth-context";
import { buildThemeVars } from "@/lib/theme";

const STORAGE_KEY_PRIMARY = "branding_primary_color";
const STORAGE_KEY_SECONDARY = "branding_secondary_color";

function applyTheme(primary?: string | null, secondary?: string | null) {
	const vars = buildThemeVars(secondary, primary);
	const root = document.documentElement;
	for (const [key, value] of Object.entries(vars)) {
		root.style.setProperty(key, value);
	}
}

// Apply cached colors immediately on module load to prevent flash
const cachedPrimary = localStorage.getItem(STORAGE_KEY_PRIMARY);
const cachedSecondary = localStorage.getItem(STORAGE_KEY_SECONDARY);
applyTheme(cachedPrimary, cachedSecondary);

type BrandingProviderProps = {
	children: React.ReactNode;
};

export function BrandingProvider({ children }: BrandingProviderProps) {
	const { user } = useAuth();

	useEffect(() => {
		const primary = user?.primary_color ?? null;
		const secondary = user?.secondary_color ?? null;

		if (primary) {
			localStorage.setItem(STORAGE_KEY_PRIMARY, primary);
		} else {
			localStorage.removeItem(STORAGE_KEY_PRIMARY);
		}
		if (secondary) {
			localStorage.setItem(STORAGE_KEY_SECONDARY, secondary);
		} else {
			localStorage.removeItem(STORAGE_KEY_SECONDARY);
		}

		applyTheme(primary, secondary);
	}, [user?.primary_color, user?.secondary_color]);

	return <>{children}</>;
}
